import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ServiceSlider from "../../components/ServiceSlider";
import { NavLink } from "react-router-dom";
import "./Services.css";

const Services = () => {
  // Generate random positions and sizes for background bubbles
  const [bubbles, setBubbles] = useState([]);
  useEffect(() => {
    const bubbleArray = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      size: `${Math.random() * 50 + 15}px`,
      delay: `${Math.random() * 10}s`,
      duration: `${Math.random() * 12 + 10}s`,
    }));
    setBubbles(bubbleArray);
  }, []);

  return (
    <div className="services-page-wrapper">
      {/* Water Bubbles Background */}
      <div className="bubble-container">
        {bubbles.map((bubble) => (
          <div
            key={bubble.id}
            className="bubble"
            style={{
              left: bubble.left,
              width: bubble.size,
              height: bubble.size,
              animationDelay: bubble.delay,
              animationDuration: bubble.duration,
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="services-hero py-5 mt-5">
        <div className="container py-5 text-center position-relative" style={{ zIndex: 2 }}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="badge bg-primary bg-opacity-10 text-primary mb-3 px-3 py-2">
              <i className="bi bi-lightning-charge-fill me-1"></i> Our Expertise
            </div>
            <h1 className="services-title mb-4">
              Innovative Solutions for the Digital Age
            </h1>
            <p className="services-subtitle">
              Empowering businesses with cutting-edge technology to solve complex challenges, optimize operations, and drive sustainable growth.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Services Split List Section */}
      <section id="services" className="py-4 position-relative" style={{ zIndex: 2 }}>
        <ServiceSlider />
      </section>

      {/* CTA Section */}
      <section className="cta-section py-5 position-relative" style={{ zIndex: 2 }}>
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="bg-white rounded-4 shadow-lg p-5 text-center position-relative overflow-hidden border border-light"
              >
                {/* Background design elements */}
                <div
                  className="position-absolute"
                  style={{
                    width: "300px",
                    height: "300px",
                    backgroundColor: "rgba(13,110,253,0.03)",
                    borderRadius: "50%",
                    top: "-150px",
                    right: "-100px",
                  }}
                ></div>
                <div
                  className="position-absolute"
                  style={{
                    width: "200px",
                    height: "200px",
                    backgroundColor: "rgba(13,110,253,0.05)",
                    borderRadius: "50%",
                    bottom: "-100px",
                    left: "-50px",
                  }}
                ></div>

                <div className="position-relative">
                  <div className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-3">
                    Get Started Today
                  </div>
                  <h2 className="display-6 fw-bold mb-4" style={{ fontFamily: "Outfit, sans-serif", color: "#243e7c" }}>
                    Ready to Transform Your Business?
                  </h2>
                  <p
                    className="lead text-secondary mb-5 mx-auto"
                    style={{ maxWidth: "700px", fontSize: "1.05rem" }}
                  >
                    Let's discuss how our tailored technology solutions can help you overcome challenges, optimize operations, and achieve your business goals.
                  </p>
                  <div className="d-flex justify-content-center flex-wrap gap-3">
                    <NavLink
                      to="/contact"
                      className="btn btn-lg px-5 py-3 rounded-pill text-white fw-semibold"
                      style={{ backgroundColor: "#243e7c", border: "none" }}
                    >
                      Schedule a Consultation
                    </NavLink>
                    <NavLink
                      to="/portfolio"
                      className="btn btn-outline-secondary btn-lg px-5 py-3 rounded-pill fw-semibold"
                    >
                      View Our Work
                    </NavLink>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
